<template>
    <el-header id="nav">
        <a :href="homeURL">
            <img src="@/assets/WTA-Player-Zone_Headers.png" alt="brand logo" />
        </a>
    </el-header>
</template>

<script>
export default {
    data() {
        return {
            mode: process.env.VUE_APP_APPLICATION_MODE,
            currentUrl: this.$route.path,
            homeURL: process.env.VUE_APP_URL_HOME,
        };
    },
    methods: {
        navigate(url) {
            this.$router.push(url);
        }
    }
};
</script>

<style lang="scss">
#nav {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    margin: 0;
    padding: 0;

    img {
        width: 100%;
        height: 100%;
    }
}

.title {
    color: white;
    font-size: 20px;
    font-weight: 600;
    padding: 16px;
    text-decoration: none !important;
}

.production-indicator {
    padding: 5px 20px;
    font-weight: bold;
    border-radius: 5px;
}

.production-indicator.production {
    background-color: white;
    color: red;
}

.production-indicator.review {
    background-color: white;
    color: green;
}

.production-indicator.development {
    background-color: white;
    color: orange;
}
</style>
